import { useState } from 'react';
import { PageTitle } from '@/components/page-title';
import { PageDescription } from '@/components/page-description';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useGetEncryptionStatus } from '@/hooks/queries/use-get-encryption-status';
import { EncryptionConfigTab } from './encryption-config-tab';
import { EncryptionStatusTab } from './encryption-status-tab';

export const EncryptionSettingsPage = () => {
  const [activeTab, setActiveTab] = useState('configuration');
  const { data: status } = useGetEncryptionStatus();

  return (
    <div className='w-full'>
      <div className='mb-6'>
        <PageTitle id='encryption-settings-title' title='Encryption' />
        <PageDescription>
          Configure envelope encryption for your organization's data at rest.
          Connect to Azure Key Vault to manage encryption keys and monitor
          encryption status across storage buckets.
        </PageDescription>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value='configuration'>Configuration</TabsTrigger>
          <TabsTrigger value='status'>Status</TabsTrigger>
        </TabsList>

        <TabsContent value='configuration' className='mt-6'>
          <EncryptionConfigTab
            existingStatus={status}
            onSaveSuccess={() => setActiveTab('status')}
          />
        </TabsContent>

        <TabsContent value='status' className='mt-6'>
          <EncryptionStatusTab
            onEditConfig={() => setActiveTab('configuration')}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
